import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import {Divider, Grid} from '@material-ui/core';
import { formatDateToDDMMYYYYFrEpoch, formatDateToDDMMYYYYHHSSFrEpoch } from '../../utils/util';
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import DividerCustom from '../../components/Divider'
import InfiniteScroll from 'react-infinite-scroll-component';
import ButtonCustom from '../../components/ButtonCustom';
import { domainName, portal_config } from '../../../portal.config';
const drawerWidth = 520;
const styles = theme => ({
    boxItemContent: {
        padding: theme.spacing(3,4,3,4),
        marginTop: theme.spacing(2),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer',
    },
    item:{
        padding: theme.spacing(0,0,2,0),
    },
    listItem: {
        paddingBottom: theme.spacing(2),
        marginBottom: theme.spacing(1),
        backgroundColor:theme.palette.background.secondary
    },

    image_bg: {
        width: 40,
        height: 40,
        borderRadius: 40,
        backgroundColor: theme.palette.background.transparent
    },
    image: {
        width: 40,
        height: 40,
        resizeMode: 'contain'
    },

    status:{
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2),
        padding: theme.spacing(0, 2, 0, 2),
        border: '1px solid',
        borderRadius: theme.spacing(4),
        textAlign: "center",
        alignItems: "center",
        height: 'fit-content',
        ...theme.palette.button.danger,
    },
    statusAdHoc:{
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2),
        padding: theme.spacing(0, 2, 0, 2),
        border: '1px solid',
        borderRadius: theme.spacing(4),
        textAlign: "center",
        alignItems: "center",
        height: 'fit-content',
        backgroundColor: theme.palette.background.other,
        color: theme.palette.text.onPrimary,
    }, 
    box:{
        padding: theme.spacing(2,2,0,0)
    },
    box_first: {
        paddingTop: theme.spacing(2)
    },
    box_second: {
        paddingTop: theme.spacing(1)
    }
});

function WalletJournalsView(props) {
    const { classes, t, transactions, currency, handleLoadMore, showLoadMore, hasMore, showLoading } = props;
    //console.log('transaction item= ', transactions)
    //console.log("profile======== ", profileName)
    return (
        <div>
                <DrawerCustom
                    open={props.open}
                    onClose={()=>props.handleDrawerOtherToggle('transactions')}
                    title = {t('wallet_journals')}
                    children={
                        <Grid item>
                            <Grid item container justify='center' alignItems='center'>
                                {showLoading&&<CustomizedCircularProgress/>}
                            </Grid>
                            {transactions&&<Grid xs={12} item>
                                <InfiniteScroll
                                    dataLength={transactions.length} //This is important field to render the next data
                                    next={handleLoadMore}
                                    hasMore={hasMore}
                                    loader={showLoadMore? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                                    height={window.innerHeight}
                                    >
                                    <Grid xs={12} item>
                                        {transactions.map((item,index)=><WalletJournalItem classes={classes} key ={index} t={t}
                                                                                            item = {item} currency={currency} 
                                                                                            onClickDetail={props.onClickDetail}
                                                                                            transactionDetail={props.transactionDetail}
                                                                                            showDetail={props.showDetail}/>
                                        )}
                                    </Grid>
                                </InfiniteScroll>
                            </Grid>}
                    </Grid>
                    }/>

        </div>
    );
}

function WalletJournalItem(props){
    const {item, classes, currency, t} = props
    var showDetail = props.showDetail && props.transactionDetail && props.transactionDetail.id && props.transactionDetail.id === item.id;
    var reward_event = item && item.reward_event ? item.reward_event : null;
    var financial_event = item && item.financial_event ? item.financial_event : null;
    var wallet_fee = item && item.wallet_fee ? item.wallet_fee : null;
    var order = item && item.order ? item.order : null;
    const getType = () =>{
        if(reward_event && reward_event.type){
            return(
                <CustomTypo mg_top_sm mg_left_xl size="xs" color={item.type != "CREDIT" ? 'error' : 'success'} variant='subtitle2'>
                    {mappingCode(reward_event.type, t)}
                </CustomTypo>
            )
        }
        else if(financial_event && financial_event.type){
            return(
                <CustomTypo mg_top_sm mg_left_xl size="xs" color={item.type === 'CREDIT' ? 'success' : 'danger'} variant='subtitle2'>
                    {mappingCode(financial_event.type, t)}
                </CustomTypo>
            )
        }
        else if(wallet_fee && wallet_fee.type){
            return(
                <CustomTypo mg_top_sm mg_left_xl size="xs" style={{color: portal_config[domainName].customColorWalletFee ? portal_config[domainName].customColorWalletFee : undefined}} variant='subtitle2'>
                {/* {wallet_fee.type} */}
                {mappingCode('Wallet_Fee', t)}
                </CustomTypo>
            )
        }
        else if(order){
            return(
                <CustomTypo mg_top_sm mg_left_xl size="xs" color={'error'} variant='subtitle2'>
                {t('financial_event_order')}
            </CustomTypo>
            )
        }
        // else{
        //     return(
        //         <CustomTypo mg_top_sm mg_left_xl size="xs" color={'success'} variant='subtitle2'>
        //         {t('pass_redeemed')}
        //     </CustomTypo>
        //     )
        // }
    }
    return(
        <div>
        <Grid xs={12} item container className={classes.boxItemContent} onClick={()=>props.onClickDetail(item)}>
            <Grid xs={12} item container direction='row'>
                <Grid item xs={6}>
                    <CustomTypo mg_top_sm variant='body2' color='secondary'>
                        {item.posted_on ? formatDateToDDMMYYYYHHSSFrEpoch(item.posted_on) : ""}
                    </CustomTypo>
                </Grid>
                <Grid item xs={6} container justify='flex-end'>
                    <ButtonCustom  size="xs" color={item.type === 'CREDIT' ? 'green' : 'danger'}>
                        {item.type}
                    </ButtonCustom>
                </Grid>
            </Grid>

            <Grid xs={12} item container alignItems='center'>
                <Grid item xs={2} xl={1}>
                    <CustomTypo mg_top_sm variant='subtitle2' color='secondary'>
                            {currency}{item.amount ? item.amount.toFixed(2) : "0.00"}
                        </CustomTypo> 
                </Grid>
                <Grid item xs={10} xl ={11}>
                {getType()}
                </Grid>
                    
            </Grid>

            {showDetail && reward_event && <Grid item xs={12} className={classes.box}>
                <Divider />
                <Grid item xs={12} container direction='row' className={classes.box_first}>
                    <Grid item xs={6}>
                        <CustomTypo variant='subtitle2'>{ t('reward_event')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo size="xs" color={item.type != "CREDIT" ? 'error' : 'success'} variant='subtitle2'>
                            {mappingCode(reward_event.type, t)}
                        </CustomTypo>
                    </Grid>
                </Grid>
                {reward_event.amount > 0 && <Grid item xs={12} container direction='row'  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('reward_event_amout')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='body1'>{currency}{reward_event.amount ? reward_event.amount.toFixed(2): '0.00'}</CustomTypo>
                    </Grid>
                </Grid>}
                {reward_event.spend_method && <Grid item xs={12} container direction='row' alignItems="center"  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('reward_event_spend_method')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='body1'>{mappingCode(reward_event.spend_method, t)}</CustomTypo>
                    </Grid>
                </Grid>}
                {reward_event.state && <Grid item xs={12} container direction='row' alignItems="center"  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('reward_event_state')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo size="xs" color={reward_event.state != 'POSTED' ? 'error' : 'success'} variant='subtitle2'>
                            {reward_event.state}
                        </CustomTypo>
                    </Grid>
                </Grid>}
                {reward_event.date && <Grid item xs={12} container direction='row'  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('reward_event_date')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='body1'>{reward_event.date ? formatDateToDDMMYYYYFrEpoch(reward_event.date) : ""}</CustomTypo>
                    </Grid>
                </Grid>}
                {reward_event.reward_offer && reward_event.reward_offer.name && <Grid item xs={12} container direction='row'  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('reward_event_offer_name')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='body1'>{reward_event.reward_offer.name}</CustomTypo>
                    </Grid>
                </Grid>}
            </Grid>}

            {showDetail && financial_event && <Grid item xs={12} className={classes.box}>
                <Divider />
                <Grid item xs={12} container direction='row' className={classes.box_first}>
                    <Grid item xs={6}>
                        <CustomTypo variant='subtitle2'>{ t('financial_event')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo size="xs" color={financial_event.type === 'TOP_UP' ? 'success' : 'danger'} variant='subtitle2'>
                            {mappingCode(financial_event.type, t)}
                        </CustomTypo>
                    </Grid>
                </Grid>
                {financial_event.amount > 0 && <Grid item xs={12} container direction='row'  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('financial_event_amount')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='body1'>{currency}{financial_event.amount ? financial_event.amount.toFixed(2) : '0.00'}</CustomTypo>
                    </Grid>
                </Grid>}
                {financial_event.number && <Grid item xs={12} container direction='row'  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('financial_event_number')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='body1'>{financial_event.number}</CustomTypo>
                    </Grid>
                </Grid>}
                {financial_event.life_cycle_state && <Grid item xs={12} container direction='row' alignItems="center"  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('financial_event_life_cycle_state')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo size="xs" color={financial_event.life_cycle_state === 'POSTED' ? 'success' : 'error'} variant='subtitle2'>
                            {financial_event.life_cycle_state}
                        </CustomTypo>
                    </Grid>
                </Grid>}
                {financial_event.date && <Grid item xs={12} container direction='row'  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('financial_event_date')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='body1'>{financial_event.date ? formatDateToDDMMYYYYFrEpoch(financial_event.date) : ""}</CustomTypo>
                    </Grid>
                </Grid>}
            </Grid>}
            
            {showDetail && wallet_fee && <Grid item xs={12} className={classes.box}>
                <Divider />
                <Grid item xs={12} container direction='row' className={classes.box_first}>
                    <Grid item xs={6}>
                        <CustomTypo variant='subtitle2'>{ t('wallet_fee')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end' variant='subtitle2'>
                        {/* <CustomTypo variant='subtitle2' size="xs" color={wallet_fee.type === 'CREDIT' ? 'success' : 'danger'}>
                            {wallet_fee.type}
                        </CustomTypo> */}
                    </Grid>
                </Grid>
                {wallet_fee.name && <Grid item xs={12} container direction='row'  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('wallet_fee_name')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='body1'>{wallet_fee.name}</CustomTypo>
                    </Grid>
                </Grid>}
            </Grid>}
            
            {showDetail && order && <Grid item xs={12} className={classes.box}  >
                <Divider />
                <Grid item xs={12} container direction='row' className={classes.box_first}>
                    <Grid item xs={6}>
                        <CustomTypo variant='subtitle2'>{ t('journal_order')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                    </Grid>
                </Grid>
                {order.number && <Grid item xs={12} container direction='row'  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('journal_order_number')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='body1'>{order.number}</CustomTypo>
                    </Grid>
                </Grid>}
                {order.total_cost && <Grid item xs={12} container direction='row'  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('journal_order_total_cost')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='body1'>{currency}{order.total_cost ? order.total_cost.toFixed(2) : '0.00'}</CustomTypo>
                    </Grid>
                </Grid>}
                {order.submitted_on && <Grid item xs={12} container direction='row'  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('journal_order_submitted_on')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='body1'>{order.submitted_on ? formatDateToDDMMYYYYFrEpoch(order.submitted_on) : ""}</CustomTypo>
                    </Grid>
                </Grid>}
                {order.fulfilled_by && order.fulfilled_by.name && <Grid item xs={12} container direction='row'  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('journal_order_fulfilled_by')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='body1'>{order.fulfilled_by.name}</CustomTypo>
                    </Grid>
                </Grid>}
            </Grid>}
        </Grid>

        </div>
    )
}

function mappingCode(state, t){
    if(state=="TOP_UP"){
        return t('financial_event_top_up');
    }else if(state=='TRANSFER'){
        return t('financial_event_transfer');
    }else if(state=='INSTANT'){
        return t('spend_method_instant');
    }else if(state=='AUTOMATIC_SPEND'){
        return t('spend_method_automatic');
    }else if(state=='ON_REQUEST'){
        return t('spend_method_on_request');
    }else if(state == 'Wallet_Fee'){
        return t('wallet_fee')
    }else if (state == 'AWARD') {
        return t('award');
    }else if (state == 'SPEND') {
        return t('spend');
    }
    return "";
}
export default withStyles(styles)(withTranslation()(WalletJournalsView));